import ApiService from "./api.service";
export default class FicheHotelService extends ApiService {
    static base_url = `${super.base_url}/fiche_hotels`;
}
